module.exports = __webpack_public_path__ + "fonts/fa-regular-400.c524051.woff2";